import { render } from "./HeaderSidebar.vue?vue&type=template&id=7a21e226&scoped=true"
import script from "./HeaderSidebar.vue?vue&type=script&lang=js"
export * from "./HeaderSidebar.vue?vue&type=script&lang=js"

import "./HeaderSidebar.vue?vue&type=style&index=0&id=7a21e226&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a21e226"]])

export default __exports__